import es from './es'
import en from './en'

const resources = {
  es,
  en
}

export default resources
